import React from "react"
import Button from '@mui/material/Button'
import { useNavigate } from "react-router-dom";

export default function BotaoVoltar() {
    const nav = useNavigate();
    return (
		<div className="row">
			<div className="col-12 align-right">
				<Button variant="contained" className="button-secondary" onClick={ () => nav(-1) }>Voltar</Button>
			</div>
		</div>
    );
};
